import api from "../../config/client.axios.api";

export const getTotalTakePictureFrameApiRequest = async ({
  active,
  startDate,
  endDate,
}: any) => {
  const response = await api.get(
    `/history/take-picture-of-frame?startDate=${startDate}&endDate=${endDate}&active=${active}`
  );
  return response.data;
};
